/* ============================================================
   ZENZENA – UI chování (design system, část 3)
   ------------------------------------------------------------
   Dva úkoly, čistě prezentační:

   1) data-zz-atc (níž) - lepivá lišta s cenou.
   2) img[data-zz-defer] - odložené obrázky. Viz initDeferredImages.

   K bodu 1:

   data-zz-atc – řídí lepivou lištu s cenou na mobilu.
   Motiv ji ukazuje teprve poté, co uživatel projde kolem
   hlavního tlačítka, a u konce stránky ji zase schová. Na
   produktovce, kde je cena ~1 100 px pod ohybem, to znamená,
   že návštěvnice z reklamy nevidí cenu ani košík. Tady je
   pravidlo obrácené: lišta je vidět vždycky, kromě chvíle,
   kdy je na obrazovce hlavní tlačítko Do košíku.

   Bez animační smyčky – jede to na IntersectionObserveru,
   takže se při scrollování nic nepočítá.

   Průsvitný materiál hlavičky si řeší sama sections/zenzena-navbar.liquid
   přes `.zznav.is-solid`; dřívější přepínač pro themovou hlavičku tu už není.
   ============================================================ */
(function () {
  'use strict';

  var root = document.documentElement;

  /* ---------- Lepivá lišta s cenou ------------------------- */
  function initStickyBuyBar() {
    var bar = document.querySelector('product-sticky-add-to-cart');
    if (!bar) return;

    // Hlavní (nelepivé) tlačítko Do košíku uvnitř produktové sekce.
    // Scope na .shopify-section--main-product je důležitý: quick-buy
    // u souvisejících produktů si dělá vlastní <buy-buttons>.
    var mainSection = document.querySelector('.shopify-section--main-product');
    var inline = mainSection && mainSection.querySelector('buy-buttons');

    // Bez hlavního tlačítka nemáme co sledovat – lištu neřídíme
    // a necháme na ní původní logiku motivu.
    if (!inline) return;

    var set = function (away) {
      root.setAttribute('data-zz-atc', away ? 'away' : 'near');
    };

    // Výchozí stav: při načtení je tlačítko hluboko pod ohybem,
    // takže lišta má být vidět hned – ne až po prvním scrollu.
    set(true);

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        set(!entries[0].isIntersecting);
      },
      // Malá rezerva, aby lišta neproblikla přesně na hraně.
      { rootMargin: '-24px 0px -96px 0px', threshold: 0 }
    );

    observer.observe(inline);
  }

  /* ---------- Odložené obrázky ----------------------------
     Obrázek s atributem data-zz-defer přijde ze serveru bez src
     a srcset (snippets/media.liquid, parametr defer). Tady se mu
     vrátí, a to podle toho, co nastane dřív:

     - stránka se načte (událost load), hlavní fotka už je
       stažená, takže další fotky jí nekradou pásmo
     - návštěvnice sáhne na galerii, chce listovat a fotky musí
       být hned (pointerdown přijde dřív než click na lupu)
     - obrázek mimo galerii se přiblíží k obrazovce (300 px)

     Proč ne jen loading="lazy": Chrome na pomalém připojení
     stahuje „líné" obrázky až 2 500 px dopředu a vodorovně
     sousedící fotky v karuselu bere jako viditelné. Na 4G tak
     další fotky galerie (~400 kB) stahoval současně s hlavní
     fotkou a ta se načítala 8 s (Lighthouse, reálné škrcení).

     V editoru motivu se všechno odhalí hned, ať nikoho nemate
     prázdná karta.
     ---------------------------------------------------------- */
  function revealImage(img) {
    if (!img.hasAttribute('data-zz-defer')) return;
    if (img.dataset.zzSrcset) img.setAttribute('srcset', img.dataset.zzSrcset);
    if (img.dataset.zzSrc) img.setAttribute('src', img.dataset.zzSrc);
    img.removeAttribute('data-zz-defer');
    img.removeAttribute('data-zz-srcset');
    img.removeAttribute('data-zz-src');
  }

  function revealWithin(scope) {
    var list = (scope || document).querySelectorAll('img[data-zz-defer]');
    for (var i = 0; i < list.length; i++) revealImage(list[i]);
  }

  function initDeferredImages() {
    if (!document.querySelector('img[data-zz-defer]')) return;

    if (window.Shopify && window.Shopify.designMode) {
      revealWithin(document);
      return;
    }

    if (document.readyState === 'complete') {
      setTimeout(function () { revealWithin(document); }, 0);
    } else {
      window.addEventListener('load', function () {
        setTimeout(function () { revealWithin(document); }, 0);
      }, { once: true });
    }

    var onTouch = function (event) {
      var gallery = event.target && event.target.closest && event.target.closest('product-gallery');
      if (gallery) revealWithin(gallery);
    };
    ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (type) {
      document.addEventListener(type, onTouch, { passive: true, capture: true });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            revealImage(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '300px 0px' });

      var outside = document.querySelectorAll('img[data-zz-defer]');
      for (var i = 0; i < outside.length; i++) {
        // Fotky v galerii ne: vodorovně sousedí s první fotkou,
        // takže by je observer odhalil hned a nic by se neušetřilo.
        if (!outside[i].closest('product-gallery')) io.observe(outside[i]);
      }
    }
  }

  function init() {
    initStickyBuyBar();
    initDeferredImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify překresluje sekce v editoru motivu – po překreslení
  // je potřeba znovu najít tlačítko.
  document.addEventListener('shopify:section:load', function () {
    initStickyBuyBar();
    revealWithin(document);
  });
})();
